import React from 'react';
import PatientManualRegistrationKDARForm, {
	PatientManualRegistrationKDARFormValues,
} from './PatientManualRegistrationKDARForm';
import useWorkplacePatient, { PatientData } from '../../../../Hooks/useWorkplacePatient';
import { HealthPlanCode } from '../../../../../../Enums/HealthPlanCode.enum';
import useHelpers from '../../../../../Base/Hooks/useHelpers';

interface Props {
	workplaceId: string;
	setIsLoading: (isLoading: boolean) => void;
}

const PatientManualRegistrationKDAR: React.FC<Props> = ({setIsLoading, workplaceId}) => {
	const { handleString } = useHelpers();
	const { createPatient } = useWorkplacePatient();
	const handleCzechRegistrationSuccess = async (
		values: PatientManualRegistrationKDARFormValues,
	) => {
		setIsLoading(true);
		const data: PatientData = {
			sendEmailInvitation: values.sendPatientInviteToMeddi,
			patient: {
				firstName: values.firstName,
				lastName: values.lastName,
				address: values.address,
				insuranceCompanyTermItemId: handleString(
					values.healthInsuranceCompany?.value,
				),
				insuranceNumber: values.insuranceNumber,
			},
			legalRepresentative: values.legalRepresentative ?? undefined,
			healthPlanCode: HealthPlanCode.KDAR,
			note: values?.note,
		};

		const patient: any = await createPatient(data, workplaceId);
		if (patient) {
			//@ts-ignore
			window.location.href = `/treatment/default/${patient.data.userId}?handle=createHealthPlan&params%5BhealthPlanCode%5D=${HealthPlanCode.KDAR}`;
		}
		setIsLoading(false);
	}

	return <PatientManualRegistrationKDARForm onSuccess={handleCzechRegistrationSuccess}/>
}

export default PatientManualRegistrationKDAR